import React, { FC } from "react";

import { DocumentIcon, InvoiceIcon, MenuPersonIcon, ReportClaimIcon, ShieldIcon } from "@/assets/icons";
import { isNotEmpty } from "@/core/string";

export type ObjectType = "policyholder" | "contract" | "claim" | "insuredgood" | "invoice";

type ObjectTypeIconProps = {
    type: ObjectType | null;
};

const ObjectTypeIcon: FC<ObjectTypeIconProps> = ({ type }) => {
    if (isNotEmpty(type)) {
        switch (type.replace(" ", "").toLocaleLowerCase()) {
            case "policyholder":
                return <MenuPersonIcon />;
            case "contract":
                return <DocumentIcon />;
            case "claim":
                return <ReportClaimIcon />;
            case "insuredgood":
                return <ShieldIcon />;
            case "invoice":
                return <InvoiceIcon />;

            case "default":
                return <></>;
        }
    }
    return <></>;
};

export default ObjectTypeIcon;
